import {
  FiCheckCircle,
  FiClock,
  FiCreditCard,
  FiDollarSign,
  FiFileText,
  FiPackage,
  FiUser
} from "react-icons/fi";
import { HiHomeModern } from "react-icons/hi2";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { CommonEnums, UserRoles } from "../constants/enums";
import { formatCurrency } from "../utils/Formatters";
import formatDate from "../utils/formatDate";
import { getAllApproversByRole, getApproverEmailByRole, getApproverMobileByRole, getApproverNameByRole } from "../utils/tokenUtils";

const employeedata = [
  {
    id: 1,
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@example.com",
    roleId: "Saler",
    username: "johndoe",
    employeeId: "EMP001",
    mobileNo: "9876543210",
    departmentId: "Marketing",
    designationId: "Saler",
    assignManagerId: 1001,
    setPassword: "password123",
    status: "Approved",
    image: "/assets/img/media/JKTLOGO.jpg",
  },
  {
    id: 2,
    firstName: "Jane",
    lastName: "Smith",
    email: "jane.smith@example.com",
    roleId: "Sales VP",
    username: "janesmith",
    employeeId: "EMP002",
    mobileNo: "8765432109",
    departmentId: "Marketing",
    designationId: "Sales VP",
    assignManagerId: 1002,
    setPassword: "password456",
    status: "Pending",
    image: "/assets/img/media/JKTLOGO.jpg",
  },
  {
    id: 3,
    firstName: "Robert",
    lastName: "Johnson",
    email: "robert.johnson@example.com",
    roleId: "Sales Manger",
    username: "robertj",
    employeeId: "EMP003",
    mobileNo: "7654321098",
    departmentId: "Marketing",
    designationId: "Sales Manger",
    assignManagerId: 1003,
    setPassword: "password789",
    status: "Approved",
    image: "/assets/img/media/JKTLOGO.jpg",
  },
  {
    id: 4,
    firstName: "Alice",
    lastName: "Brown",
    email: "alice.brown@example.com",
    roleId: "C&C Customer",
    username: "aliceb",
    employeeId: "EMP004",
    mobileNo: "6543210987",
    departmentId: "Credit & Collection",
    designationId: "C&C Responsible",
    assignManagerId: 1004,
    setPassword: "password123",
    status: "Approved",
    image: "/assets/img/media/JKTLOGO.jpg",
  },
  {
    id: 5,
    firstName: "Michael",
    lastName: "Wilson",
    email: "michael.wilson@example.com",
    roleId: "Customer Service",
    username: "michaelw",
    employeeId: "EMP005",
    mobileNo: "5432109876",
    departmentId: "Customer Service",
    designationId: "Supervisor",
    assignManagerId: 1005,
    setPassword: "password456",
    status: "Approved",
    image: "/assets/img/media/JKTLOGO.jpg",
  },
  {
    id: 6,
    firstName: "Emma",
    lastName: "Davis",
    email: "emma.davis@example.com",
    roleId: "C&C Manager",
    username: "emmad",
    employeeId: "EMP006",
    mobileNo: "4321098765",
    departmentId: "Credit & Collection",
    designationId: "C&C Manager",
    assignManagerId: 1006,
    setPassword: "password789",
    status: "Approved",
    image: "/assets/img/media/JKTLOGO.jpg",
  },
  {
    id: 7,
    firstName: "William",
    lastName: "Martinez",
    email: "william.martinez@example.com",
    roleId: "C&C Customer",
    username: "williamm",
    employeeId: "EMP007",
    mobileNo: "3210987654",
    departmentId: "Customer Relations",
    designationId: "C&C Customer",
    assignManagerId: 1007,
    setPassword: "password123",
    status: "Approved",
    image: "/assets/img/media/JKTLOGO.jpg",
  },
];

export { employeedata };

export const ExisitingCustomerData = [
  {
    id: 1,
    accountnumber: "000000000000",
    accountname: "ABC Name",
    receivable: "$50,000",
    pastduebalance: "$5000",
    totalcreditline: "$10000",
    guaranteeamount: "$30000",
    unusedcredit: "$70000",
  },
  {
    id: 2,
    accountnumber: "000000000000",
    accountname: "ABC Name",
    receivable: "$50,000",
    pastduebalance: "$5000",
    totalcreditline: "$10000",
    guaranteeamount: "$30000",
    unusedcredit: "$70000",
  },

  {
    id: 3,
    accountnumber: "000000000000",
    accountname: "ABC Name",
    receivable: "$50,000",
    pastduebalance: "$5000",
    totalcreditline: "$10000",
    guaranteeamount: "$30000",
    unusedcredit: "$70000",
  },

  {
    id: 4,
    accountnumber: "000000000000",
    accountname: "ABC Name",
    receivable: "$50,000",
    pastduebalance: "$5000",
    totalcreditline: "$10000",
    guaranteeamount: "$30000",
    unusedcredit: "$70000",
  },

  {
    id: 5,
    accountnumber: "000000000000",
    accountname: "ABC Name",
    receivable: "$50,000",
    pastduebalance: "$5000",
    totalcreditline: "$10000",
    guaranteeamount: "$30000",
    unusedcredit: "$70000",
  },

  {
    id: 6,
    accountnumber: "000000000000",
    accountname: "ABC Name",
    receivable: "$50,000",
    pastduebalance: "$5000",
    totalcreditline: "$10000",
    guaranteeamount: "$30000",
    unusedcredit: "$70000",
  },

  {
    id: 7,
    accountnumber: "000000000000",
    accountname: "ABC Name",
    receivable: "$50,000",
    pastduebalance: "$5000",
    totalcreditline: "$10000",
    guaranteeamount: "$30000",
    unusedcredit: "$70000",
  },
];

export const InvoiceData = Array.from({ length: 10 }, (_, index) => ({
  id: index + 1,
  customername: `Customer ${index + 1}`,
  customernumber: `34${Math.floor(100000000 + Math.random() * 900000000)}`,
  documentType: ["Invoice", "Credit Note", "Debit Note"][
    Math.floor(Math.random() * 3)
  ],
  invoicedate: new Date(
    2025,
    Math.floor(Math.random() * 12),
    Math.floor(Math.random() * 28) + 1
  )
    .toISOString()
    .split("T")[0],
  duddate: new Date(
    2025,
    Math.floor(Math.random() * 12),
    Math.floor(Math.random() * 28) + 1
  )
    .toISOString()
    .split("T")[0],
  dispatchdate: new Date(
    2025,
    Math.floor(Math.random() * 12),
    Math.floor(Math.random() * 28) + 1
  )
    .toISOString()
    .split("T")[0],
  baselinedate: new Date(
    2025,
    Math.floor(Math.random() * 12),
    Math.floor(Math.random() * 28) + 1
  )
    .toISOString()
    .split("T")[0],
  tyrefamily: ["TRS", "SUV", "Heavy Duty", "Passenger", "Truck", "Bus"][
    Math.floor(Math.random() * 6)
  ],
  invoicetotal: `$${Math.floor(Math.random() * 10000) + 500}`,
  amountpaid: `$${Math.floor(Math.random() * 10000)}`,
  outstandingamount: `$${Math.floor(Math.random() * 10000)}`,
  aging: `${Math.floor(Math.random() * 90)} days`,
  invoicestatus: ["Paid", "Unpaid", "Partially Paid"][
    Math.floor(Math.random() * 3)
  ],
}));

export const creaditNote = [
  {
    id: 1,
    customername: "Distribuidora del",
    customernumber: "3456789067",
    invoiceno: "00001",
    invoicedate: "2025-03-12",
    duddate: "2025-03-12",
    dispatchdate: "2025-03-12",
    baselinedate: "2025-03-12",
    tiresfamily: "TRS",
    invoicetotal: "$1200",
    amountpaid: "$1200",
    outstandingamount: "$0.00",
    invoicestatus: "Pending",
  },
  {
    id: 2,
    customername: "Distribuidora del",
    customernumber: "3456789067",
    invoiceno: "00001",
    invoicedate: "2025-03-12",
    duddate: "2025-03-12",
    dispatchdate: "2025-03-12",
    baselinedate: "2025-03-12",
    tiresfamily: "TRS",
    invoicetotal: "$1200",
    amountpaid: "$1200",
    outstandingamount: "$0.00",
    invoicestatus: "Pending",
  },
  {
    id: 3,
    customername: "Distribuidora del",
    customernumber: "3456789067",
    invoiceno: "00001",
    invoicedate: "2025-03-12",
    duddate: "2025-03-12",
    dispatchdate: "2025-03-12",
    baselinedate: "2025-03-12",
    tiresfamily: "TRS",
    invoicetotal: "$1200",
    amountpaid: "$1200",
    outstandingamount: "$0.00",
    invoicestatus: "Pending",
  },
];

export const DashboardCustomerData = [
  {
    id: 1,
    customername: "John Doe",
    businesstype: "Dealer",
    personalDetails: {
      fullName: "John Doe",
      email: "john.doe@example.com",
      phone: "123-456-7890",
      billingAddress: "123 Billing St, City, Country",
      shippingAddress: "456 Shipping Rd, City, Country",
      address: "789 Main St, City, Country",
    },
    salesRepresentative: {
      seller1: { name: "TBR" },
    },
    otherDetails: {
      customerType: "Premium",
      defaultCurrency: "MXN",
      portalStatus: "Active",
    },
    receivable: "$50,000",
    pastduebalance: "$5000",
    totalcreditline: "$10000",
    guaranteeamount: "$30000",
    unusedcredit: "$70000",
  },
  {
    id: 2,
    customername: "Jane Smith",
    businesstype: "Dealer",
    salesRepresentative: {
      seller1: { name: "TBR" },
      seller2: { name: "PCR" },
      seller3: { name: "LVC" },
    },
    personalDetails: {
      fullName: "Jane Smith",
      email: "jane.smith@example.com",
      phone: "987-654-3210",
      billingAddress: "321 Billing St, City, Country",
      shippingAddress: "654 Shipping Rd, City, Country",
      address: "987 Main St, City, Country",
    },
    otherDetails: {
      customerType: "Standard",
      defaultCurrency: "EUR",
      portalStatus: "Inactive",
    },
    receivable: "$40,000",
    pastduebalance: "$3000",
    totalcreditline: "$8000",
    guaranteeamount: "$25000",
    unusedcredit: "$60000",
  },
  {
    id: 3,
    customername: "Michael Johnson",
    businesstype: "Dealer",
    personalDetails: {
      fullName: "Michael Johnson",
      email: "michael.johnson@example.com",
      phone: "555-555-5555",
      billingAddress: "789 Billing St, City, Country",
      shippingAddress: "321 Shipping Rd, City, Country",
      address: "654 Main St, City, Country",
    },
    salesRepresentative: {
      seller1: { name: "TBR" },
      seller2: { name: "PCR" },
      seller3: { name: "LVC" },
    },
    otherDetails: {
      customerType: "Enterprise",
      defaultCurrency: "GBP",
      portalStatus: "Active",
    },
    receivable: "$60,000",
    pastduebalance: "$7000",
    totalcreditline: "$12000",
    guaranteeamount: "$35000",
    unusedcredit: "$80000",
  },
];

export const InvoiceCustomerData = [
  {
    id: 1,
    InvoiceNumber: "F00202769",
    FiscalFolio: "6F0FEFFB-0B9A-44B1-A5F6-22DE48EBD08D",
    InvoiceDate: "2025-05-12",
    TotalInv: "$1200",
    OutAmount: "$1000",
    PurchaseOrderNo: "20250312",
    DispatchDate: "2025-03-12",
    DeliveryDate: "2025-03-12",
    TaxIdNo: "AEVE630716MX5",
    SkuDetails: "XYZ",
    view: "👁️",
  },
  {
    id: 2,
    InvoiceNumber: "00202768",
    FiscalFolio: "0A9DC553-D9A7-415B-8771-CED96A79B668",
    InvoiceDate: "2025-05-12",
    TotalInv: "$1200",
    OutAmount: "$1000",
    PurchaseOrderNo: "2025-03-12",
    DispatchDate: "2025-03-12",
    DeliveryDate: "2025-03-12",
    TaxIdNo: "AEVE630716MX5",
    SkuDetails: "ABC",
    view: "👁️",
  },
];

export const creaditcustomerNote = [
  {
    id: 1,
    FiscalFolio: "1F23D541-8B3C-49BD-B7BD-F1EF2C10CF73",
    CreditNoteNumber: "10016068",
    CustomerNumber: "0003100138",
    CreditNoteDate: "2025-05-05",
    CustomerTaxId: "AEVE630716MX5",
    TotalcreditnoteAmount: "1137.960000",
    Remarks: "PROMO 3% VOL PEDIDO 230",
  },
  {
    id: 2,
    FiscalFolio: "58FC11B7-C639-48B2-8FC6-6044403B7FB0",
    CreditNoteNumber: "10016110",
    CustomerNumber: "0003100138",
    CreditNoteDate: "2025-05-07",
    CustomerTaxId: "AEVE630716MX5",
    TotalcreditnoteAmount: "13112.530000",
    Remarks: "DPP 1.5 Y 4% F-00200343 A F-0020183",
  },
];

export const CfidSummery = [
  {
    id: 1,
    reference: "F-0000301",
    uuid: "1234567891011XXX",
    invdate: "1/4/2025",
    cfditype: "INVOICE",
    amount: "500000",
    currency: "MXP",
    satvalidationstatus: "Valid",
  },
  {
    id: 2,
    reference: "F-0000301",
    uuid: "1234567891011XX2",
    invdate: "28/4/2025",
    cfditype: "CREDIT NOTE",
    amount: " 250,000.00 ",
    currency: "MXP",
    satvalidationstatus: "Valid",
  },
  {
    id: 3,
    reference: "F-0000301",
    uuid: "1234567891011XXX",
    invdate: "",
    cfditype: "PAYMENT COMPLEMENT",
    amount: "",
    currency: "MXP",
    satvalidationstatus: "",
  },
  {
    id: 4,
    reference: "F-0000301",
    uuid: "1234567891011XXX",
    invdate: "1/4/2025",
    cfditype: "ADVANCE PAYMENT",
    amount: " 15,000.00 ",
    currency: "MXP",
    satvalidationstatus: "Valid",
  },
];

export const LogisticCustomer = Array.from({ length: 10 }, (_, index) => {
  const statuses = ["TRANSIT", "DELIVERED", "PENDING"];
  const freightliners = ["MSC", "TRANSPORTES OREGA", "MAERSK", "HAPAG-LLOYD"];
  const transportTypes = ["CAJA SECA 53", "PLATAFORMA", "REFRIGERADA", ""];
  const currency = "MXN";

  const randomDate = () =>
    new Date(Date.now() - Math.floor(Math.random() * 180 * 24 * 60 * 60 * 1000))
      .toISOString()
      .split("T")[0];

  const status = statuses[Math.floor(Math.random() * statuses.length)];
  const deliveryDate = status === "DELIVERED" ? randomDate() : "";
  const typeOfTransport =
    status === "DELIVERED"
      ? transportTypes[Math.floor(Math.random() * transportTypes.length)]
      : "";

  return {
    id: index + 1,
    Reference: `F-00${Math.floor(Math.random() * 90000 + 10000)}`,
    Amount: `${(Math.random() * 900000 + 100000).toFixed(2)}`,
    Currency: currency,
    InvoiceDate: randomDate(),
    DispatchDate: randomDate(),
    Eta: randomDate(),
    Bl: `BL${Math.floor(Math.random() * 1000000)}`,
    Freightliner:
      freightliners[Math.floor(Math.random() * freightliners.length)],
    TruckPlates: `PLT-${Math.floor(Math.random() * 9000 + 1000)}`,
    Status: status,
    DeliveryDate: deliveryDate,
    TypeTrasport: typeOfTransport,
  };
});

export const disputeData = [
  {
    id: 1,
    disputeid: "1",
    customername: "John doe",
    invoicenumber: "3456789067",
    escalationcontact: "Carloz Parez",
    escalationtrigger: "3 days",
    escalationdate: "2025-03-12",
    dispatchdate: "2025-03-12",
    currentlevel: "Level-1",
    resolutiondeadline: "2025-03-12",
    status: "under Review",
    comment: "Reviewing the delivery details.",
  },
  {
    id: 2,
    disputeid: "2",
    customername: "Jane Smith",
    invoicenumber: "3456789067",
    escalationcontact: "Carloz Parez",
    escalationtrigger: "3 days",
    escalationdate: "2025-03-12",
    dispatchdate: "2025-03-12",
    currentlevel: "Level-1",
    resolutiondeadline: "2025-03-12",
    status: "under Review",
    comment: "Reviewing the delivery details.",
  },
  {
    id: 3,
    disputeid: "3",
    customername: "Michael Johnson",
    invoicenumber: "3456789067",
    escalationcontact: "Carloz Parez",
    escalationtrigger: "3 days",
    escalationdate: "2025-03-12",
    dispatchdate: "2025-03-12",
    currentlevel: "Level-1",
    resolutiondeadline: "2025-03-12",
    status: "under Review",
    comment: "Reviewing the delivery details.",
  },
];

export const AdminDashboardCustomerdata = [
  {
    id: 1,
    name: "John Doe",
    account_number: "12345687",
    receivable: "$89786.00",
    balance: "$89786.00",
    total: "$89786.00",
    gurantee_amount: "$89786.00",
    unused_credit: "$89786.00",
    // email: "john.doe@example.com",
    // type: "Domestic",
    // date: "2025-01-03",
    // status: "Approved",
    image: "/assets/img/media/JKTLOGO.jpg",
  },
  {
    id: 2,
    name: "Jane Smith",
    account_number: "12345687",
    receivable: "$89786.00",
    balance: "$89786.00",
    total: "$89786.00",
    gurantee_amount: "$89786.00",
    unused_credit: "$89786.00",
    // email: "jane.smith@example.com",
    // type: "International",
    // date: "2025-01-05",
    // status: "Pending",
    image: "/assets/img/media/JKTLOGO.jpg",
  },
  {
    id: 3,
    name: "Robert Johnson",
    account_number: "12345687",
    receivable: "$89786.00",
    balance: "$89786.00",
    total: "$89786.00",
    gurantee_amount: "$89786.00",
    unused_credit: "$89786.00",
    // email: "robert.johnson@example.com",
    // type: "Domestic",
    // date: "2025-01-07",
    // status: "Approved",
    image: "/assets/img/media/JKTLOGO.jpg",
  },
];

const creditcustomerdata = [
  {
    id: 1,
    customername: "John Smith",
    customernumber: "CUST001",
    credittern: "30 Days",
    creditamount: "2000000",
    salespotiential: "High",
    approvalstatus: 0,
    madecashpurchase: "Yes",
  },
  {
    id: 2,
    customername: "Maria Garcia",
    customernumber: "CUST002",
    credittern: "60 Days",
    creditamount: "5000000",
    salespotiential: "Medium",
    approvalstatus: 0,
    madecashpurchase: "No",
  },
  {
    id: 3,
    customername: "Liam Johnson",
    customernumber: "CUST003",
    credittern: "45 Days",
    creditamount: "4000000",
    salespotiential: "Low",
    approvalstatus: 0,
    madecashpurchase: "Yes",
  },
  {
    id: 4,
    customername: "Emma Davis",
    customernumber: "CUST004",
    credittern: "30 Days",
    creditamount: "7000000",
    salespotiential: "Medium",
    approvalstatus: 0,
    madecashpurchase: "No",
  },
  {
    id: 5,
    customername: "Noah Wilson",
    customernumber: "CUST005",
    credittern: "90 Days",
    creditamount: "2000000",
    salespotiential: "High",
    approvalstatus: 0,
    madecashpurchase: "Yes",
  },
];

export { creditcustomerdata };

export const permissiondata = [
  {
    id: 1,
    employee: "John",
    roleId: "CFO",
    privilage: ["Approval Customer", "Credit Limit Approval"],
  },
  {
    id: 2,
    employee: "Alice",
    roleId: "Manager",
    privilage: ["Approval Customer", "Credit Limit Approval"],
  },
];

export const slaapprovaldata = [
  {
    id: 1,
    role: "Sales VP",
    slaapprovalday: "2",
  },
  {
    id: 2,
    role: "C&C Customer",
    slaapprovalday: "2",
  },
  {
    id: 3,
    role: "C&C Manager",
    slaapprovalday: "2",
  },
];

export const Privilegesroledata = [
  {
    id: 1,
    roleId: "Sales Manager",
    privilage: ["Approval Customer"],
  },
  {
    id: 2,
    roleId: "Sales VP",
    privilage: ["Approval Customer", "Credit Limit Approval"],
  },
];

export const RaisedDisputeData = [
  {
    id: 1,
    disputeid: "1",
    customername: "John doe",
    dateraised: "12/04/25",
    DisputeCategory: "logistic",
    ReferenceNumber: "F-23424543",
    DisputeDescription: "Raised against logistic",
    Attachments: "👁️",
    AssignedTo: "Seller",
    ResolutionComments: "jkasbvjksdb",
    ResolutionDate: "",
    Status: "update",
  },
  {
    id: 2,
    disputeid: "2",
    customername: "John doe",
    dateraised: "12/04/25",
    DisputeCategory: "logistic",
    ReferenceNumber: "F-23424543",
    DisputeDescription: "Raised against logistic",
    Attachments: "👁️",
    AssignedTo: "Seller",
    ResolutionComments: "jkasbvjksdb",
    ResolutionDate: "",
    Status: "update",
  },
  {
    id: 3,
    disputeid: "3",
    customername: "John doe",
    dateraised: "12/04/25",
    DisputeCategory: "logistic",
    ReferenceNumber: "F-23424543",
    DisputeDescription: "Raised against logistic",
    Attachments: "👁️",
    AssignedTo: "Seller",
    ResolutionComments: "jkasbvjksdb",
    ResolutionDate: "",
    Status: "update",
  },
];

export const PaymentReportData = [
  {
    id: 1,
    customername: "John Doe",
    invoicenumber: "3456789067",
    payment: "SL0001",
    invoiceamount: "$7867.00",
    paymentdate: "2025-03-12",
    refrence: "TRX00001",
    paymentmode: "2025-03-12",
    invoiceamount: "$7867.00",
    paidamount: "$4567.00",
    paymentstatus: "Applied",
  },
  {
    id: 2,
    customername: "John Doe",
    invoicenumber: "3456789067",
    payment: "SL0002",
    paymentdate: "2025-03-12",
    refrence: "TRX00002",
    paymentmode: "2025-03-12",
    invoiceamount: "$7867.00",
    paidamount: "$4567.00",
    paymentstatus: "Applied",
  },
  {
    id: 3,
    customername: "John Doe",
    invoicenumber: "3456789067",
    invoiceamount: "$7867.00",
    payment: " SL0003",
    paymentdate: "2025-03-12",
    refrence: "TRX00003",
    paymentmode: "2025-03-12",
    invoiceamount: "$7867.00",
    paidamount: "$4567.00",
    paymentstatus: "Applied",
  },
];

export const DashboardCustomer = [
  {
    id: 1,
    date: "2025-01-03",

    amount: "$50,000",
    moneyreception: "$5000",
    reference: "$10000",
    moneyapplied: "$30000",
  },
  {
    id: 2,
    date: "2025-01-03",

    amount: "$50,000",
    moneyreception: "$5000",
    reference: "$10000",
    moneyapplied: "$30000",
  },
  {
    id: 3,
    date: "2025-01-03",

    amount: "$50,000",
    moneyreception: "$5000",
    reference: "$10000",
    moneyapplied: "$30000",
  },
];

export const ViewAccountStatementData = [
  {
    id: 1,
    documentnumber: "F-000120",
    documenttype: "Invoice Credit",
    tiretype: "CAR & VAM",
    assignment: "F-001120",
    dispatcheddate: "2025-03-12",
    marchandisereceptiondate: "2025-03-12",
    paymentdays: "30",
    duedays: "2025-03-12",
    aging: "9",
    invoiceamount: "$550,000.00",
    documentbalance: "$500,000.00",
    payment: "480,000.00",
    difference: "$20,000.00",
    typeofshortpayment: "$20,000.00",
    remark: "Price Difference",
    dunningnoticedue: "Addtional Discount 4%",
    ref1: "-",
    ref2: "-",
  },

  {
    id: 2,
    documentnumber: "F-000120",
    documenttype: "Invoice Credit",
    tiretype: "CAR & VAM",
    assignment: "F-001120",
    dispatcheddate: "2025-03-12",
    marchandisereceptiondate: "2025-03-12",
    paymentdays: "30",
    duedays: "2025-03-12",
    aging: "9",
    invoiceamount: "$550,000.00",
    documentbalance: "$500,000.00",
    payment: "480,000.00",
    difference: "$20,000.00",
    typeofshortpayment: "$20,000.00",
    remark: "Price Difference",
    dunningnoticedue: "Addtional Discount 4%",
    ref1: "-",
    ref2: "-",
  },
  {
    id: 3,
    documentnumber: "F-000120",
    documenttype: "Invoice Credit",
    tiretype: "CAR & VAM",
    assignment: "F-001120",
    dispatcheddate: "2025-03-12",
    marchandisereceptiondate: "2025-03-12",
    paymentdays: "30",
    duedays: "2025-03-12",
    aging: "9",
    invoiceamount: "$550,000.00",
    documentbalance: "$500,000.00",
    payment: "480,000.00",
    difference: "$20,000.00",
    typeofshortpayment: "$20,000.00",
    remark: "Price Difference",
    dunningnoticedue: "Addtional Discount 4%",
    ref1: "-",
    ref2: "-",
  },
];

export const businessunitdata = [
  {
    id: 1,
    name: "Car & Vam",
  },
  {
    id: 2,
    name: "TBR",
  },
  {
    id: 3,
    name: "FARM",
  },
  {
    id: 4,
    name: "Brazil",
  },
  {
    id: 5,
    name: "LATAM",
  },
  {
    id: 6,
    name: "USA",
  },
];

export const Departmentdata = [
  {
    id: 1,
    name: "Marketing",
  },
  {
    id: 2,
    name: "Logistic",
  },
  {
    id: 3,
    name: "Credit & Collection",
  },
  {
    id: 4,
    name: "Customer Service",
  },
];

export const Designationdata = [
  {
    id: 1,
    Departmentid: "Marketing",
    name: "Saler",
  },
  {
    id: 2,
    Departmentid: "Credit & Collection",
    name: "C&C Supervisor",
  },
  {
    id: 3,
    Departmentid: "Customer Service",
    name: "Supervisor",
  },
  {
    id: 4,
    Departmentid: "Marketing",
    name: "Sales Manger",
  },
  {
    id: 4,
    Departmentid: "Marketing",
    name: "Sales VP",
  },
  {
    id: 4,
    Departmentid: "Credit & Collection",
    name: "C&C Manager",
  },
  {
    id: 5,
    Departmentid: "Logistic",
    name: "Logistic Supervisor",
  },
  {
    id: 6,
    Departmentid: "Logistic",
    name: "Logistic Manager",
  },
];

export const multilevelapprovaldata = [
  {
    id: 1,
    name: "Onboarding Approval",
    customerType: "Domestic",
    businessUnit: ["Car & Vam", "TBR", "FARM"],
    role: ["saler", "Sales Manager", "Sales VP", "C&C customer"],
  },
  {
    id: 2,
    name: "Onboarding Approval",
    customerType: "International",
    businessUnit: ["Brazil", "LATAM", "USA"],
    role: [
      "Customer Service",
      "Sales VP",
      "C&C Supervisor",
      "C&C Manager",
      "CFO",
    ],
  },
  {
    id: 3,
    name: "CREDIT LIMIT Approval",
    customerType: "Domestic",
    businessUnit: ["Car & Vam", "TBR", "FARM"],
    role: ["saler", "Sales Manager", "Sales VP", "C&C Manager", "CFO"],
  },
];

export const roledata = [
  {
    id: 1,
    name: "Saler",
  },
  {
    id: 2,
    name: "Sales Manager",
  },
  {
    id: 3,
    name: "Sales VP",
  },
  {
    id: 4,
    name: "C&C Manager",
  },
  {
    id: 5,
    name: "C&C Supervisor",
  },
  {
    id: 6,
    name: "CFO",
  },
  {
    id: 7,
    name: "CEO",
  },
  {
    id: 8,
    name: "Customer Service",
  },
  {
    id: 9,
    name: "C&C Customer ",
  },
  {
    id: 10,
    name: "Customer",
  },
  {
    id: 11,
    name: "Logistic Manager",
  },
  {
    id: 12,
    name: "Logistic Supervisor",
  },
];

// paymentData.js

const paymentData = Array.from({ length: 10 }, (_, index) => ({
  id: index + 1,
  customername: `Customer ${index + 1}`,
  date: new Date(
    2025,
    Math.floor(Math.random() * 12),
    Math.floor(Math.random() * 28) + 1
  )
    .toISOString()
    .split("T")[0],
  advancepayment: `$${(Math.random() * 1000).toFixed(2)}`,
  paidpayment: `$${(Math.random() * 500).toFixed(2)}`,
  amount: `$${(Math.random() * 1500).toFixed(2)}`,
  duddate: new Date(
    2025,
    Math.floor(Math.random() * 12),
    Math.floor(Math.random() * 28) + 1
  )
    .toISOString()
    .split("T")[0],
  paymentstatus: Math.random() > 0.5 ? "Appiled" : "Not Applied",
  bankname: ["ABC Bank", "XYZ Bank", "QRS Bank", "LMN Bank"][
    Math.floor(Math.random() * 4)
  ],
  balancedue: `$${(Math.random() * 1000).toFixed(2)}`,
  Ref: Math.random() > 0.7 ? `Ref-${Math.floor(Math.random() * 10000)}` : "---",
}));

export { paymentData };

// PaymentCustomerData.js

export const PaymentCustomerData = Array.from({ length: 10 }, (_, index) => {
  const randomDate = new Date(
    Date.now() - Math.floor(Math.random() * 365 * 24 * 60 * 60 * 1000)
  )
    .toISOString()
    .split("T")[0]; // Generates random date within the last year

  return {
    id: index + 1,
    invoice: String(10000 + index),
    assignmentnumber: `94500${Math.floor(Math.random() * 10000)}`,
    documenttype: ["Invoice", "Credit Note"][Math.floor(Math.random() * 2)],
    invoicedate: randomDate,
    amount: (Math.random() * 50000 + 10000).toFixed(2),
    balance: (Math.random() * 30000).toFixed(2),
    totalpayment: (Math.random() * 50000).toFixed(2),
    partialpayment: 0,
    refrence_number: "",
    total: (Math.random() * 50000 + 10000).toFixed(2),
    paymentstatus: ["Applied", "Not Applied", "Paid"][
      Math.floor(Math.random() * 3)
    ],
  };
});

export const CustomerInvoiceTrasactionData = Array.from(
  { length: 10 },
  (_, index) => {
    const randomDate = new Date(
      Date.now() - Math.floor(Math.random() * 365 * 24 * 60 * 60 * 1000)
    )
      .toISOString()
      .split("T")[0];

    return {
      id: index + 1,
      customerName: `Customer ${index + 1}`,
      customerNumber: `CN-100${index + 1}`,
      invoiceNumber: `INV-200${index + 1}`,
      invoiceDate: randomDate,
      amountPaid: (Math.random() * 50000 + 10000).toFixed(2),
      amountOutstanding: (Math.random() * 30000).toFixed(2),
      referenceNumber: `Ref-${Math.floor(Math.random() * 10000)}`,
      paymentStatus: ["Applied", "Not Applied", "Paid"][
        Math.floor(Math.random() * 3)
      ],
    };
  }
);

export const CustomerCreditData = Array.from({ length: 10 }, (_, index) => {
  const randomInt = (min, max) =>
    Math.floor(Math.random() * (max - min + 1)) + min;

  const totalCreditLine = randomInt(30000, 100000);
  const receivable = randomInt(10000, 50000);
  const pastDueBalance = randomInt(0, 20000);
  const guaranteeAmount = randomInt(5000, 20000);
  const unusedCredit = totalCreditLine - receivable;

  return {
    id: index + 1,
    customername: `Customer ${index + 1}`,
    businesstype: ["Retail", "Wholesale", "Manufacturing", "Services"][
      randomInt(0, 3)
    ],
    receivable,
    pastduebalance: pastDueBalance,
    totalcreditline: totalCreditLine,
    guaranteeamount: guaranteeAmount,
    unusedcredit: unusedCredit < 0 ? 0 : unusedCredit,
  };
});

export const DisputeCustomerData = Array.from({ length: 10 }, (_, index) => {
  const departments = ["Finance", "Sales", "Logistics", "Customer Service"];
  const triggers = ["Late Delivery", "Wrong Invoice", "Missing Items", "Other"];
  const levels = ["L1", "L2", "L3", "Manager"];
  const statuses = ["Open", "In Progress", "Resolved", "Escalated"];
  const comments = [
    "Awaiting response from client.",
    "Escalated to management.",
    "Issue under review.",
    "Resolved and closed.",
    "Pending internal verification.",
  ];

  const randomDate = () =>
    new Date(Date.now() - Math.floor(Math.random() * 90 * 24 * 60 * 60 * 1000))
      .toISOString()
      .split("T")[0];

  return {
    disputeid: 1000 + index,
    department: departments[Math.floor(Math.random() * departments.length)],
    escalationcontact: Math.floor(Math.random() * 9000000000 + 1000000000), // Random 10-digit number
    escalationtrigger: triggers[Math.floor(Math.random() * triggers.length)],
    dispatchdate: randomDate(),
    currentlevel: levels[Math.floor(Math.random() * levels.length)],
    status: statuses[Math.floor(Math.random() * statuses.length)],
    comment: comments[Math.floor(Math.random() * comments.length)],
  };
});

export const CFDIData = Array.from({ length: 10 }, (_, index) => {
  const cfditypes = ["I", "E", "T", "P"]; // Common CFDI types (Ingreso, Egreso, Traslado, Pago)
  const currencies = ["USD", "MXN", "EUR"];
  const validationStatuses = ["Valid", "Invalid", "Pending"];

  const randomDate = () =>
    new Date(Date.now() - Math.floor(Math.random() * 365 * 24 * 60 * 60 * 1000))
      .toISOString()
      .split("T")[0];

  return {
    reference: `REF-${Math.floor(Math.random() * 90000 + 10000)}`,
    uuid: Math.floor(Math.random() * 1e12), // Random 12-digit UUID number
    invdate: randomDate(),
    cfditype: cfditypes[Math.floor(Math.random() * cfditypes.length)],
    amount: parseFloat((Math.random() * 100000 + 1000).toFixed(2)),
    currency: currencies[Math.floor(Math.random() * currencies.length)],
    satvalidationstatus:
      validationStatuses[Math.floor(Math.random() * validationStatuses.length)],
  };
});

export const totalDeposited = Math.floor(Math.random() * 100000) + 1;

/**
 * Converts a .NET JSON date string (e.g., "/Date(1632096000000)/") to "YYYY-MM-DD" format.
 * @param {string} dotNetDateStr - The .NET date string.
 * @returns {string|null} - The formatted date in "YYYY-MM-DD", or null if invalid.
 */
export function formatDotNetDate(dotNetDateStr) {
  if (typeof dotNetDateStr !== "string") return null;

  const match = dotNetDateStr.match(/\/Date\((\d+)\)\//);
  if (!match) return dotNetDateStr;

  const timestamp = parseInt(match[1], 10);
  if (isNaN(timestamp)) return null;

  const date = new Date(timestamp);
  return date.toISOString().split("T")[0]; // returns "YYYY-MM-DD"
}

function parseAccountingNumber(value) {
  if (typeof value === "string" && value.trim().endsWith("-")) {
    value = "-" + value.trim().slice(0, -1);
  }
  return parseFloat(value) || 0;
}


export function generateDashboardData(t, userInfo = {}, user = {}) {
const availableCreditValue = formatCurrency(
  parseAccountingNumber(userInfo?.CreditLine) - parseAccountingNumber(userInfo?.OutBal)
);
const SPACE = "\u00A0\u00A0"; // two non-breaking spaces

const availableCreditWithCurrency = `${availableCreditValue}${SPACE}${userInfo?.Currency || "MXN"}`;
const creditline = `${formatCurrency(userInfo?.CreditLine)}${SPACE}${userInfo?.Currency || "MXN"}`
  const statusCardData = [
    {
      title: t("customerdashboard.currency"),
      value: userInfo?.Currency || "N/A",
      icon: <FiDollarSign size={24} />,
      color: "text-blue-600",
      bgColor: "bg-blue-100",
    },
    {
      title: t("customerdashboard.outstandingbalance"),
      value: `${formatCurrency(parseAccountingNumber(userInfo?.OutBal))}${SPACE}${userInfo?.Currency || "MXN"}`,
      icon: <MdOutlineAccountBalanceWallet size={24} />,
      color: "text-blue-600",
      bgColor: "bg-blue-100",
    },
    {
      title: t("customerdashboard.creditline"),
      value:creditline,
      icon: <FiCreditCard size={24} />,
      color: "text-blue-600",
      bgColor: "bg-blue-100",
    },

    {
      title: t("customerdashboard.availablecredit"),
     value: availableCreditWithCurrency,
      icon: <FiCheckCircle size={24} />,
      color: "text-red-600",
      bgColor: "bg-red-100",
    },
    {
      title: t("customerdashboard.pastdue"),
      value: `${formatCurrency(parseAccountingNumber(userInfo?.PastDue))}${SPACE}${userInfo?.Currency || "MXN"}`,
      icon: <FiClock size={24} />,
      color: "text-red-600",
      bgColor: "bg-red-100",
    },
    {
      title: t("customerdashboard.PromissoryNote"),
      value: formatCurrency(userInfo?.GuaranteeAmt),
      icon: <FiPackage size={24} />,
      color: "text-purple-600",
      bgColor: "bg-purple-100",
      extra: (

        <div className="flex items-center">
          <div className="p-3 rounded-full text-green-600 bg-purple-100">
            <HiHomeModern className="text-purple-600 text-lg sm:text-xl" />
          </div>
          <div className="ml-4">
            <div className="text-sm font-medium text-gray-500">
              {t("customerdashboard.validity")}
            </div>
            <div className="text-lg font-semibold text-purple-600">
              {formatDate(userInfo?.Validity)}
            </div>
          </div>
        </div>
      ),
    },
    // user?.regionName?.toLowerCase() !== CommonEnums.MEXICO?.toLowerCase() && {
    {
      title: t("customerdashboard.creditinsurance"),
      value: "Yes",
      icon: <FiPackage size={24} />,
      color: "text-green-600",
      bgColor: "bg-green-100",
      extra: (
        <div className="flex items-center">
          <div className="p-3 rounded-full text-green-600 bg-green-100">
            <HiHomeModern className="text-green-600 text-lg sm:text-xl" />
          </div>
          <div className="ml-4">
            <div className="text-sm font-medium text-gray-500">
              {t("customerdashboard.Mortgage")}
            </div>
            <div className="text-lg font-semibold text-green-600">
              {(user?.typeOfGuarantee || CommonEnums.NO) === CommonEnums.NO
                ? t("details.no")
                : t("details.yes")}
            </div>
          </div>
        </div>
      )
}
  ].filter(Boolean);;

  const accountDetails = {
    customer: {
      label: t("customerdashboard.customer"),
      value: userInfo?.CustomerNumber || user?.username || "Not Assigned",
      icon: <FiUser className="mr-2" />,
    },
    name: {
      label: t("customerdashboard.name"),
      value: userInfo?.CustomeName || user?.firstName || "N/A",
      icon: <FiUser className="mr-2" />,
    },
    salesManagers: {
      label: t("customerdashboard.SalesManager"),
      icon: <FiFileText className="mr-2" />,
      isMultiple: true,
      managers: getAllApproversByRole(user, UserRoles?.SALES_MANAGER),
      value: getApproverNameByRole(user, UserRoles?.SALES_MANAGER) || "N/A",
      email: getApproverEmailByRole(user, UserRoles?.SALES_MANAGER) || "N/A",
      mobile: getApproverMobileByRole(user, UserRoles?.SALES_MANAGER) || "N/A",
    },
    ccexecutive: {
      label: t("customerdashboard.ccexecutive"),
      value: getApproverNameByRole(user, UserRoles?.CCSUPERVISOR) || "N/A",
      icon: <FiUser className="mr-2" />,
     email: getApproverEmailByRole(user, UserRoles?.CCSUPERVISOR) || "N/A",
       mobile: getApproverMobileByRole(user, UserRoles?.CCSUPERVISOR) || "N/A",
    },
    CustomerServiceResponsible: {
      label: t("customerdashboard.CustomerServiceResponsible"),
      value: getApproverNameByRole(user, UserRoles?.CUSTOMER_SERVICE) || "N/A",
      icon: <FiUser className="mr-2" />,
     email: getApproverEmailByRole(user, UserRoles?.CUSTOMER_SERVICE) || "N/A",
      mobile: getApproverMobileByRole(user, UserRoles?.CUSTOMER_SERVICE) || "N/A",
    },

    LosgisticsResponsible: {
      label: t("customerdashboard.LosgisticsResponsible"),
      value:
        getApproverNameByRole(user, UserRoles?.LOGISTIC_RESPONSIBLE) || "N/A",
      icon: <FiUser className="mr-2" />,
      email: getApproverEmailByRole(user, UserRoles?.LOGISTIC_RESPONSIBLE) || "N/A",
      mobile: getApproverMobileByRole(user, UserRoles?.LOGISTIC_RESPONSIBLE) || "N/A",
    },

  };

  return { statusCardData, accountDetails };
}

export const executiveDashboardData = {
  domestic: {
    totalReceivables: 1250000,
    totalpaid: 100000000,
    creditLineUtilization: 68,
    disputeCases: 24,
    avgCollectionDays: 42,
    logisticIssues: 5,
    collectionEfficiency: 85,
    collectionEfficiencyChange: 2.5,
    avgPaymentDays: 45,
    topRegion: "North America",
    disputeStatus: {
      pending: 12,
      needMoreInfo: 6,
      resolved: 42,
      other: 3,
    },
  },
  international: {
    totalReceivables: 850000,
    totalpaid: 75000000,
    creditLineUtilization: 45,
    disputeCases: 18,
    avgCollectionDays: 55,
    logisticIssues: 8,
    currencyExposure: "USD 2.5M",
    topCountry: "Germany",
    forexImpact: -3.2,
    disputeStatus: {
      pending: 8,
      needMoreInfo: 4,
      resolved: 28,
      other: 2,
    },
  },
};

// Sample user data that would come from Redux
export const sampleUserInfo = {
  OutBal: 0, // Outstanding Balance
  name: "John Doe",
  role: "Executive",
  creditLimit: 2000000,
};
